import { render, staticRenderFns } from "./RemarkButcmp.vue?vue&type=template&id=2e834c28&scoped=true"
import script from "./RemarkButcmp.vue?vue&type=script&lang=js"
export * from "./RemarkButcmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e834c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e834c28')) {
      api.createRecord('2e834c28', component.options)
    } else {
      api.reload('2e834c28', component.options)
    }
    module.hot.accept("./RemarkButcmp.vue?vue&type=template&id=2e834c28&scoped=true", function () {
      api.rerender('2e834c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/component/RemarkButcmp.vue"
export default component.exports